/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export default [
  {
    width: 180,
    label: '项目参与人',
    tip: '请输入关键字',
    key: 'userName',
    id: 'userName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '经营者',
    tip: '请输入关键字',
    key: 'userName',
    id: 'operator',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '个体',
    tip: '请输入关键字',
    key: 'userEnterpriseName',
    id: 'userEnterpriseName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '手机号',
    tip: '请输入手机号',
    key: 'phone',
    id: 'phone',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '启用状态',
    tip: '请选择启用状态',
    key: 'status',
    id: 'status',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '全部',
        key: ''
      },
      {
        name: '启用',
        key: 1
      },
      {
        name: '禁用',
        key: 2
      }
    ]
  },
  {
    width: 180,
    tip: '请选择订单类型',
    key: 'invoiceOrderType',
    id: 'invoiceOrderType',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '支付订单',
        key: 1
      },
      {
        name: '综合服务费',
        key: 2
      }
    ]
  },
  {
    width: 180,
    label: '当前交易结构',
    tip: '请选择',
    key: 'taxCollectionPattern',
    id: 'taxCollectionPattern',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '汇总申报',
        key: 1
      },
      {
        name: '委托代开',
        key: 2
      },
      {
        name: '委托代发',
        key: 3
      },
      {
        name: '运营基地',
        key: 4
      },
      {
        name: '委托代开(线上)',
        key: 6
      },
      {
        name: '工具',
        key: 9
      }
    ]
  }
];
